import React from 'react';
import { ListItem } from './list-item';
import { ListResultsProps } from 'app/area/company-reports-administration/list/types-store';
import styles from './list-results.scss';

export const ListResults: React.FC<ListResultsProps> = ({
  listItems, deletingCompanyReports, deleteCompanyReport, translation
}) => listItems?.length > 0
    ? <div className={styles.listItems}>
      {listItems.map(listItem => {
        return <ListItem
          key={listItem.code.value}
          item={listItem}
          deleting={deletingCompanyReports?.includes(listItem.code.value)}
          deleteCompanyReport={deleteCompanyReport}
          translation={translation}
        />;
      })}
    </div>
    : null;
